import { render, staticRenderFns } from "./MuiRadio.vue?vue&type=template&id=524edb89&scoped=true"
import script from "./MuiRadio.vue?vue&type=script&lang=js"
export * from "./MuiRadio.vue?vue&type=script&lang=js"
import style0 from "./MuiRadio.vue?vue&type=style&index=0&id=524edb89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524edb89",
  null
  
)

export default component.exports